<template lang="pug">
v-menu(v-model="showMenu" rounded="lg" allow-overflow :close-on-content-click="false" offset-y attach nudge-bottom="8" max-width="320" content-class="custom-picker")
  template(v-slot:activator="{ on, attrs }")
    v-text-field.round-xl(v-model="date" hide-details outlined dense placeholder="Date" v-bind="attrs" v-on="on" readonly)
  .pa-1.white
    yc-date-picker(:parentDate.sync="selectedDate" @change="dateChanged")
    
</template>

<script>
export default {
  name: 'DateDropdown',
  props: ['parentDate'],
  data () {
    return {
      showMenu: false,
      date: null,
      selectedDate: null
    }
  },
  watch: {
    parentDate: {
      immediate: true,
      handler (value) {
        if (!value) {
          this.date = null
          this.selectedDate = null
        } else if (value && !this.date) {
          this.date = value
          this.selectedDate = value
        }
      }
    }
  },
  methods: {
    dateChanged () {
      this.showMenu = false
      this.date = this.selectedDate
      this.$emit('update:parentDate', this.selectedDate)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .custom-picker {
  left: 0px !important;
}
</style>